import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Landmark, Users, Scale, Boxes, TrendingUp, ShoppingBag } from 'lucide-react';

const subsidySchemes = [
  { name: 'RIPS 2024', path: '/subsidies/rips-2024', icon: <Landmark className="w-6 h-6" /> },
  { name: 'PMEGP', path: '/subsidies/pmegp', icon: <Users className="w-6 h-6" /> },
  { name: 'VYUPY', path: '/subsidies/vyupy', icon: <Scale className="w-6 h-6" /> },
  { name: 'MSME Policy', path: '/subsidies/msme-policy-2024', icon: <Boxes className="w-6 h-6" /> },
  { name: 'Export Policy', path: '/subsidies/export-policy-2024', icon: <TrendingUp className="w-6 h-6" /> },
  { name: 'Trade Policy 2025', path: '/trade-policy', icon: <ShoppingBag className="w-6 h-6" /> },
];

export const HomeSubsidies = () => (
  <section className="py-20 bg-[#f8fafc]" data-testid="subsidies-quick-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mb-12"
      >
        <span className="inline-block px-4 py-2 bg-white rounded-full text-sm font-medium text-[#3b5998] mb-4 shadow-sm">
          Government Subsidies
        </span>
        <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-[#0f172a] mb-4">
          Popular Subsidy Schemes
        </h2>
        <p className="text-[#64748b] max-w-2xl mx-auto">
          Access government benefits designed to support your business growth
        </p>
      </motion.div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {subsidySchemes.map((scheme, index) => (
          <motion.div
            key={scheme.name}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: index * 0.05 }}
          >
            <Link
              to={scheme.path}
              className="block bg-white p-5 rounded-xl border border-slate-100 hover:border-[#00bcd4]/50 hover:shadow-lg transition-all text-center group"
            >
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-gradient-to-br from-[#3b5998]/10 to-[#00bcd4]/10 flex items-center justify-center text-[#3b5998] group-hover:from-[#3b5998] group-hover:to-[#00bcd4] group-hover:text-white transition-all">
                {scheme.icon}
              </div>
              <p className="font-medium text-[#0f172a] text-sm">{scheme.name}</p>
            </Link>
          </motion.div>
        ))}
      </div>

      <div className="text-center mt-8">
        <Link
          to="/subsidies"
          className="inline-flex items-center gap-2 text-[#3b5998] font-medium hover:text-[#00bcd4] transition-colors"
        >
          View All Schemes
          <ArrowRight size={18} />
        </Link>
      </div>
    </div>
  </section>
);
